import { Fragment, useEffect, useState, useImperativeHandle } from "react";
import { Dialog } from "@headlessui/react";
import { WrapperChatSender, TextChatSender } from "components/moleculs/Chats";
import ChatForm from "./ChatForm";

const OfflineChat = ({ offlineRefs, childRef }) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(offlineRefs, () => ({
        openModal() {
            openModal();
        }
    }));

    function openModal() {
        setOpen(true);
    }
    return (
        <Fragment>
            {open ? (
                <Dialog
                    open={true}
                    onClose={() => setOpen(false)}
                    className="relative z-50"
                >
                    <div className="fixed inset-0">
                        <Dialog.Panel className="w-fit fixed phone:max-w-[340px] max-w-[364px] bg-neutral-10 phone:py-4 py-6 z-[99999999] rounded-lg bottom-[96px] right-8 phone:right-4 phone:bottom-[96px]">
                            <div className="flex items-center space-x-4 px-6 phone:px-4">
                                <img src="/images/universal/arrow-left.svg" className="phone:w-5 phone:h-5 w-6 h-6" alt="arrow-left" />
                                <div className="flex items-center space-x-3 relative">
                                    <img src="/images/universal/chat-avatar.svg" className="w-10 h-10" alt="chat-avatar" />
                                    <svg className="w-[16px] h-[16px] absolute bottom-0 left-[18px]" alt="online" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7.5" r="6" fill="#808896" stroke="white" strokeWidth="2" />
                                    </svg>
                                    <div className="flex flex-col justify-between gap-2">
                                        <h3 className="text-md font-semibold text-neutral-100 leading-[20px] tracking-text-sm">Anonymous Proxies</h3>
                                        <p className="text-xs font-normal text-neutral-50 leading-[15px] tracking-text">Offline</p>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t border-neutral-30 w-full relative mt-5 mb-6"></div>
                            <div className="scrollbar-hide mb-6 px-6 phone:px-4 pb-16">
                                <div className="mb-10">
                                    <div className="flex items-start space-x-3">
                                        <img src="/images/universal/chat-avatar.svg" className="w-10 h-10" alt="chat-avatar" />
                                        <WrapperChatSender>
                                            <TextChatSender>Welcome Anonymous Proxies! You can ask a question, leave a comment, or view a demo here.</TextChatSender>
                                        </WrapperChatSender>
                                    </div>
                                    <div className="flex items-start space-x-3 mt-2">
                                        <div className="w-8 h-8"></div>
                                        <WrapperChatSender>
                                            <TextChatSender>We’re offline ut tortor gravida. Lacinia tristique mattis cursus sit sit nisi</TextChatSender>
                                        </WrapperChatSender>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t border-neutral-30 w-full relative mb-4"></div>
                            <ChatForm childRef={childRef} />
                            <div className="w-full flex items-center justify-between px-6 phone:px-4">
                                <button onClick={() => childRef.current.openModal()} className="leading-[17.35px] py-[18px] h-[48px] text-[14px] flex items-center justify-center w-full font-semibold rounded-lg bg-primary-main hover:bg-primary-hover text-neutral-10 focus:outline-none focus:border-none">Send Us a Message</button>
                            </div>
                        </Dialog.Panel>
                    </div>
                </Dialog>
            ) : ""}
        </Fragment>
    );
};

export default OfflineChat;